export const ON_ANSWER = 'answer/ON_ANSWER'
export const RESET_TO_PLAY_AGAIN = 'answer/RESET_TO_PLAY_AGAIN'


// WEBPACK FOOTER //
// ./src/state/modules/answer/ActionTypes.js